module.exports = __webpack_public_path__ + "static/Maestro-Black-64c4bdecc5bed505a2b7f57074e224da.svg";